import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Spinner from '../../spinner';
import Icon from '../../icon/';

const Button = ({
  children,
  buttonType,
  type,
  style,
  size,
  status,
  collapsePadding,
  text,
  icon,
  disabled,
  isBlock,
  onClick,
  buttonRef,
  qaId,
}) => {
  let uniType = type;
  let buttonIcon;

  if (status === 'success') {
    uniType = 'confirm';
    buttonIcon = <Icon type="confirmation" isButtonIcon />;
  } else if (status === 'failure') {
    uniType = 'destroy';
    buttonIcon = <Icon type="critical" isButtonIcon />;
  } else if (status === 'spinning') {
    buttonIcon = <Spinner />;
  }

  const buttonClasses = classNames(
    'uni-btn' + (uniType ? '--' + uniType : '') + (style === 'minimal' && uniType !== 'cancel' ? '--' + style : ''),
    {
      [`uni-btn--${size}`]: size,
      'uni-btn--icon-only':
        (text === undefined || text === null || text === '') &&
        (children === undefined || children === null || children === ''),
      'uni-btn--has-status': status,
      [`uni-util__collapse-padding--${collapsePadding}`]: style === 'minimal' && collapsePadding,
      'uni-btn--block': isBlock,
    }
  );

  const buttonText = children ? children : text;

  if (icon && icon.props && !status) {
    buttonIcon = React.cloneElement(icon, { isButtonIcon: true });
  } else if (icon && !status) {
    buttonIcon = <Icon type={icon} isButtonIcon />;
  }

  return (
    <button
      type={buttonType}
      className={buttonClasses}
      disabled={disabled}
      onClick={onClick}
      ref={buttonRef}
      data-qa-id={qaId}
    >
      {buttonIcon}
      {buttonText}
    </button>
  );
};

Button.__VIABLE_SECONDARYNAV_CONTROL = true;

Button.propTypes = {
  children: PropTypes.string,
  buttonType: PropTypes.oneOf(['button', 'reset', 'submit']),
  type: PropTypes.oneOf(['primary', 'secondary', 'destroy', 'confirm', 'subtle', 'cancel']),
  style: PropTypes.oneOf(['standard', 'minimal']),
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
  status: PropTypes.oneOf(['spinning', 'success', 'failure']),
  collapsePadding: PropTypes.oneOf(['right', 'left', 'horizontal']),
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  text: PropTypes.string,
  disabled: PropTypes.bool,
  isBlock: PropTypes.bool,
  onClick: PropTypes.func,
  buttonRef: PropTypes.func,
  qaId: PropTypes.string,
};

Button.defaultProps = {
  size: 'medium',
};

export default Button;



// WEBPACK FOOTER //
// ./src/buttons/button/index.jsx